<div class="py-dialog">
<div style="display: flex;align-items: end;flex-direction:column;">
    <button nz-button
            (click)="kapa()"
            nz-wave
            style="position: absolute;"
            [routerLink]="'/🏠/🔑'"
            nzType="primary"
            nzDanger
            nzShape="circle"
            nzSize="small"><nz-icon nzType="close" />
    </button>
</div>
<div class="ui small header m-1">
    Gizlilik Seçici
</div>

<div class="scrolling content p-0">
    <div class="ui form">
        <div class="grouped fields">
            <div class="ui middle aligned divided selection list">


                <div class="item"
                     [class.active]="gizlilik==='Herkese Açık'"
                     (click)="tiklandiGizlilik('Herkese Açık');">
                    <i class="globe europe icon"></i>


                    <div class="content">
                        <a class="header">
                            Herkese Açık
                        </a>
                        <div class="description">Paylaşımınız Tüm Sistemde Herkes Tarafından Görünür</div>
                    </div>
                </div>


                <div class="item"
                     [class.active]="gizlilik==='Takipleştiklerinizle'"
                     (click)="tiklandiGizlilik('Takipleştiklerinizle');">
                    <i class="people arrows icon"></i>

                    <div class="content">
                        <a class="header">
                            Takipleştiklerinizle
                        </a>
                        <div class="description">Paylaşımınız Sizi Takip Edenlere Ve Takip Ettiklerinize Görünür
                        </div>
                    </div>
                </div>

                <div class="item"
                     [class.active]="gizlilik==='Takip Edenlerle'"
                     (click)="tiklandiGizlilik('Takip Edenlerle');">
                    <i class="people arrows icon"></i>

                    <div class="content">
                        <a class="header">
                            Takip Edenlerle
                        </a>
                        <div class="description">Paylaşımınız Sizi Takip Edenlere Görünür
                        </div>
                    </div>
                </div>

                <div class="item"
                     [class.active]="gizlilik==='Takip Ettiklerinizle'"
                     (click)="tiklandiGizlilik('Takip Ettiklerinizle');">
                    <i class="people arrows icon"></i>

                    <div class="content">
                        <a class="header">
                            Takip Ettiklerinizle
                        </a>
                        <div class="description">Paylaşımınız Sizin Takip Ettiklerinize Görünür
                        </div>
                    </div>
                </div>


                <div class="item"
                     [class.active]="gizlilik==='Listedekilerle'"
                     [class.fiko-kilit]="gelismisGizlilikKilit()"
                     (click)="tiklandiGizlilik('Listedekilerle');">
                    <div class="right floated content">
                        <div class="ui mini blue button"
                             (click)="tiklandiDialogKisiSecici();">
                            Liste
                            {{ gizlilik==='Listedekilerle'? ' ('+kisiler.length+')':'' }}
                        </div>
                    </div>
                    <i class="clipboard list icon"></i>

                    <div class="content">
                        <a class="header">
                            Listedekilerle
                        </a>
                        <div class="description">Paylaşımınız Sadece Listede Seçtiklerinize Görünür</div>
                    </div>
                </div>

                <div class="item"
                     [class.active]="gizlilik==='Listedekiler Hariç'"
                     [class.fiko-kilit]="gelismisGizlilikKilit()"
                     (click)="tiklandiGizlilik('Listedekiler Hariç');">
                    <div class="right floated content">
                        <div class="ui mini blue button"
                             (click)="tiklandiDialogKisiSecici();">
                            Liste
                            {{ gizlilik==='Listedekiler Hariç'? ' ('+kisiler.length+')':'' }}
                        </div>
                    </div>
                    <i class="headphones icon"></i>

                    <div class="content">
                        <a class="header">
                            Listedekiler Hariç
                        </a>
                        <div class="description">Paylaşımınız Listede Seçtikleriniz Hariç Herkese Görünür</div>
                    </div>
                </div>

                <div class="item"
                     [class.active]="gizlilik==='Seçilen Gruplarla'"
                     [class.fiko-kilit]="gelismisGizlilikKilit()"
                     (click)="tiklandiGizlilik('Seçilen Gruplarla');">
                    <div class="right floated content">
                        <div class="ui mini blue button">Gruplar</div>
                    </div>
                    <i class="users icon"></i>

                    <div class="content">
                        <a class="header">
                            Seçilen Gruplarla
                        </a>
                        <div class="description">Paylaşımınız Listede Seçtiğiniz Grup Üyelerine Görünür</div>
                    </div>
                </div>

                <div class="item"
                     [class.active]="gizlilik==='Seçilen Gruplar Hariç'"
                     [class.fiko-kilit]="gelismisGizlilikKilit()"
                     (click)="tiklandiGizlilik('Seçilen Gruplar Hariç');">
                    <div class="right floated content">
                        <div class="ui mini blue button">Gruplar</div>
                    </div>
                    <i class="assistive listening systems icon"></i>

                    <div class="content">
                        <a class="header">
                            Seçilen Gruplar Hariç
                        </a>
                        <div class="description">Paylaşımınız Listede Seçtiğiniz Grup Üyeleri Hariç Herkese Görünür
                        </div>
                    </div>
                </div>

                <div class="item"
                     [class.active]="gizlilik==='Sadece Ben'"
                     (click)="tiklandiGizlilik('Sadece Ben');">
                    <i class="eye slash icon"></i>

                    <div class="content">
                        <a class="header">
                            Sadece Ben
                        </a>
                        <div class="description">Paylaşımınızı Sadece Siz Görebilirsiniz</div>
                    </div>
                </div>

            </div>

        </div>
    </div>
</div>

<div class="mt-3"
     style="display: flex;align-items: end;flex-direction:row;">
    <div class="ui right red labeled animated fade icon button mini"
         (click)="kapa();"
         style="vertical-align: top;">
        <div class="visible content">
            Kapat
        </div>
        <div class="hidden content">
            Kapat
        </div>
        <i class="close icon"></i>
    </div>
    <span style="flex: 1;"></span>
    <div class="ui green labeled animated fade icon button mini"
         (click)="kaydetTiklandi()"
         *ngIf="!saltOkunur"
         style="vertical-align: top;">
        <div class="visible content">
            Kaydet
        </div>
        <div class="hidden content">
            Kaydet
        </div>
        <i class="check icon"></i>
    </div>
</div>
</div>
<!--
<div class="actions">
    <div class="ui right green labeled animated fade icon button mini"
         (click)=" this.nzModalRef?.close();"
         style="vertical-align: top;">
        <div class="visible content">
            Kapat
        </div>
        <div class="hidden content">
            Kapat
        </div>
        <i class="check icon"></i>
    </div>

    <div class="ui right red labeled animated fade icon button mini"
         (click)="kaydetTiklandi()"
         *ngIf="!saltOkunur"
         style="vertical-align: top;">
        <div class="visible content">
            Kaydet
        </div>
        <div class="hidden content">
            Kaydet
        </div>
        <i class="check icon"></i>
    </div>
</div> -->